/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { EmGroup } from "./em-group";
import { GroupType } from "./group-type";
import {Image} from './image';
import { Permission } from "./permission";
import {User} from './user';

export class Group {
  id: number;
  name: string;
  description: string;
  type: string;
  image: Image;
  uuid: string;
  users: User[];

  pagePermissions: {[propKey: string]: Permission};
  groupPermissions: GroupPermissions;
}

export class GroupPermissions {
  values: GroupPermission[]
}

export class GroupPermission {
  group: EmGroup;
  permission: Permission;
}
